import { Address } from '.'
import styled from 'styled-components'

const TitleWrapper = styled.h5`
  margin-bottom: 5px;
`

const Wrapper = styled.div`
  line-height: 2;
`
export const AddressSummary = ({ address }: { address: Address }) => {
  return (
    <Wrapper>
      <TitleWrapper>Selected address</TitleWrapper>
      <div>
        {address.nameOrNumber || address.name} {address.line1}
      </div>
      <div>{address.line2}</div>
      <div>{address.city}</div>
      <div>{address.postcode}</div>
    </Wrapper>
  )
}
